import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { ArcGisMapComponent } from '../arcgis-map/arcgis-map.component';
import { EntityPageModule } from '../entity-page/entity-page.module';
import { AccordionPanelModule } from '../shared/components/accordion-panel/accordion-panel.module';
import { ReturnFocusDirective } from '../shared/directives/return-focus.directive';
import { ConservationArchiveFolderComponent } from './conservation-archive-folder.component';
import { ConservationArchiveFolderDetailsComponent } from './conservation-archive-folder-details/conservation-archive-folder-details.component';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        TranslateModule,
        ArcGisMapComponent,
        EntityPageModule,
        AccordionPanelModule,
        ReturnFocusDirective,
    ],
    declarations: [ConservationArchiveFolderComponent, ConservationArchiveFolderDetailsComponent],
    exports: [ConservationArchiveFolderComponent],
})
export class ConservationArchiveFolderModule {}
